class PlatformEmbedded {
  constructor () {
    this._messageReceived = this._messageReceived.bind(this)
    this._updatePageHeight = this._updatePageHeight.bind(this)
    this._begin = this._begin.bind(this)
    this.lastContentHeight = 0

    this._bindEvents()
  }

  _bindEvents () {
    window.onmessage = this._messageReceived

    if (document.readyState === 'complete') {
      this._begin()
    } else {
      document.addEventListener('DOMContentLoaded', this._begin, false)
    }
  }

  _messageReceived (e) {
    if (typeof e.data !== 'string') { return }

    if (e.data.indexOf('buyapowa:scroll:') !== -1) {
      this.shareDialogTopOffset = parseInt(e.data.substring(16))
    }
  }

  _updatePageHeight () {
    const contentHeight = document.querySelector('#bp_platform_div').offsetHeight - 10

    if (this.lastContentHeight !== contentHeight) {
      window.parent.postMessage(`buyapowa:height:${contentHeight}`, '*')
      this.lastContentHeight = contentHeight
    }

    setTimeout(this._updatePageHeight, 300)
  }

  _begin () {
    window.parent.postMessage('buyapowa:loaded', '*')
    this._updatePageHeight()
  }
}

new PlatformEmbedded() // eslint-disable-line no-new
